import { Env, ENVS, getApigeeUrl, getEnv } from '@adsk/acs-sc-web-platform-api';

import { getProjectIdFromUrl, queryObjToSearchString } from './utils';

const MEETINGS_PATH_BY_ENV: Record<Env, string> = {
  [ENVS.QA]: '/bim360/meetings-qa/v1',
  [ENVS.STAGING]: '/bim360/meetings/v1',
  [ENVS.PRODUCTION]: '/bim360/meetings/v1',
};

export const getMeetingsAPIBaseUrl = ({
  projectId = getProjectIdFromUrl(),
  path = '',
  params = {},
}): string => {
  const env = getEnv();
  const apigeeUrl = getApigeeUrl();

  return `${apigeeUrl}${
    MEETINGS_PATH_BY_ENV[env]
  }/projects/${projectId}${path}${queryObjToSearchString(params)}`;
};
